import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SignupFeature } from "@/features/auth/SignupFeature";

const signupSearchSchema = z.object({
  redirect: z.string().optional(),
});

function SignupPage() {
  const { redirect } = Route.useSearch();
  return <SignupFeature redirectAfterVerify={redirect} />;
}

export const Route = createFileRoute("/(auth)/signup")({
  validateSearch: signupSearchSchema,
  component: SignupPage,
  staticData: { authorize: false },
});
